import { startLoading, stopLoading } from 'src/utils/loading';

export const useLoadingAction = async (actionFunc, ...args) => {
  startLoading();

  let onSuccess, onError;
  if (typeof args[args.length - 1] === 'function') onError = args.pop();
  if (typeof args[args.length - 1] === 'function') onSuccess = args.pop();

  try {
    const data = await actionFunc(...args); // expected { result, error }

    if (data?.result) {
      onSuccess?.(data.result);
    } else if (data?.error) {
      onError?.(data.error);
    }

    return data;
  } catch (e) {
    onError?.(e);
    return { error: e };
  } finally {
    stopLoading();
  }
};

export const useCallbackAction = async (actionFunc, ...args) => {
  let onSuccess, onError;
  if (typeof args[args.length - 1] === 'function') onError = args.pop();
  if (typeof args[args.length - 1] === 'function') onSuccess = args.pop();
  
  await actionFunc(...args,
    (result) => onSuccess?.(result),
    (error) => onError?.(error),
  );
};

// const apiCreate = (values) => useLoadingAction(insertItem, values);
// const apiUpdate = (values) => useLoadingAction(updateItem, values);
// const apiDelete = (values) => useLoadingAction(deleteItem, values);

// const apiCreate = (values) => useCallbackAction(insertItem, values, toastInserted, toastError);
// const apiUpdate = (values) => useCallbackAction(updateItem, values, toastUpdated, toastError);
// const apiDelete = (values) => useCallbackAction(deleteItem, values, toastRemoved, toastError);
